import { render, staticRenderFns } from "./BudgetSourceDetail.vue?vue&type=template&id=6bd4a8b2&scoped=true&"
import script from "./BudgetSourceDetail.vue?vue&type=script&lang=js&"
export * from "./BudgetSourceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd4a8b2",
  null
  
)

export default component.exports